<app-dialog [visible]="displayCustomDialog" [title]="dialogHeader" [showCloseButton]="false" class="max-w-[30rem]"
    (closed)="onConfirmDialogReject()">
    <ng-template #bodyTemplate>
        <div class="flex flex-col px-6 py-4 gap-3">
            <p class="mb-0" [innerHTML]="dialogMessage"></p>
            <div *ngIf="pendingAction === 'Reject'">
                <label for="rejectionComment" class="block font-medium mb-1">Comments<span
                        class="text-danger">*</span></label>
                <textarea id="rejectionComment" class="w-full p-2 border border-gray-300 rounded-base"
                    [(ngModel)]="rejectionComment" rows="3" placeholder="Enter rejection reason..."></textarea>
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button label="No" (clicked)="onConfirmDialogReject()" severity="danger" variant="outlined"
                icon="pi pi-times" />
            <app-button label="Yes" (clicked)="onConfirmDialogAccept()" severity="success" variant="outlined"
                icon="pi pi-check" />
        </div>
    </ng-template>
</app-dialog>

@if(fetchingRole){
<div class="flex justify-center items-center  h-screen">
    <div class="loader"></div>
</div>
}@else {
@if(permissions.restricted){
<!-- Cannot view contract -->
<div>
    <div class="flex flex-col items-center justify-center h-screen">
        <div class="flex flex-col items-center gap-4">
            <img [src]="'images/access_denied.png' | assetUrl" alt="404">
            <h1 class="text-2xl font-semibold text-center">You do not have permission to view this document</h1>
            <p class="text-gray-500 text-center">Please contact the owner of the document for access</p>
            <div class="mt-4">
                <app-button label="Login" variant="filled" severity="theme" (clicked)="navigateToLogin()"
                    icon="pi pi-sign-in">
                </app-button>
            </div>
        </div>
    </div>
</div>
}@else {
@if(contract){
@if(openDownloadContract) {
<app-download-doc [contract]="contract" [visibility]="openDownloadContract"
    (visibilityChange)="openDownloadContract=$event"></app-download-doc>
}
<section class="aspect-auto h-screen flex flex-col overflow-x-hidden">
    <app-contract-top-bar [view]="ContractTopBarView.HOME" [isAnonymousUser]="isAnonymousUser" [contract]="contract"
        [isOwner]="isOwner" [isSameOrganization]="isSameOrganization" [permissions]="permissions"
        [externalDocument]="externalDocument" [currentUser]="currentUser" [projectId]="projectId"
        [statusMenuItems]="statusMenuItems" [selectedStatus]="selectedStatus" [loadingStatuses]="loadingStatuses"
        [project]="project" [loading]="loading" [fileUrl]="fileUrl" [docUpdatedAt]="docUpdatedAt"
        [currentRole]="currentRole" [isEditor]="isEditor" [canDownload]="canDownloadDocument()"
        [selectedDueDate]="selectedDueDate" [currentDate]="currentDate" [projectDueDate]="projectDueDate"
        [isCurrentUserReviewedDoc]="isCurrentUserReviewedDoc" [showReviewBtn]="showReviewButton()"
        [labelText]="labelText" [actionButton]="actionButton" [supportMenuItems]="supportMenuItems"
        [infoMenuItems]="infoMenuItems" [isRecording]="isRecording" [items]="items || []" (goBackClicked)="goBack()"
        (contractNameUpdated)="updateContractName($event)"
        (statusItemClicked)="onStatusItemClick($event.item, $event.menu)" (lastModifiedRequested)="getLastModified()"
        (createDialogOpened)="openCreateDialog()" (downloadContractClicked)="downloadContract()"
        (versionsHistoryToggled)="toggleVersionsHistoryDialog()" (dueDateSelected)="handleDueDateSelect($event)"
        (dueDateCleared)="handleDueDateClear()" (reviewDocumentClicked)="reviewDocument()" (actionTriggered)="action()"
        (menuItemClicked)="handleClick($event)" [canEditStatus]="canEditStatus">
    </app-contract-top-bar>

    <div class="flex-1">
        @if(isAnonymousUser) {
        <ng-container *ngTemplateOutlet="documentSide">
        </ng-container>
        } @else if(showQuestionPanel) {
        <div class="flex h-full">
            <div class="flex-1 overflow-hidden">
                <ng-container *ngTemplateOutlet="tabsSide">
                </ng-container>
            </div>
            <div *ngIf="contract.containsForm" class="bg-white border-l pl-2 pt-2 w-[35rem] h-full">
                <app-innform-question-sidepanel [contract]="contractId" [question]="getCurrentSources().questionId"
                    [sources]="getCurrentSources().sources" [(activeTabIndex)]="questionSidePanelActiveTabIndex"
                    [userRole]="currentRole"
                    (closePanelEvent)="toggleQuestionPanel(false)"></app-innform-question-sidepanel>
            </div>
        </div>
        }
        @else {
        <z-resizable class="w-full h-full" (zResizeStart)="onResizeStart()" (zResize)="onResizing()"
            (zResizeEnd)="onResizeEnd($event)">
            <z-resizable-panel [zDefaultSize]="panelSizes[0]" [zMin]="minPanelSizes[0]" class="overflow-hidden">
                <ng-container *ngTemplateOutlet="documentSide">
                </ng-container>
            </z-resizable-panel>
            <z-resizable-handle [zWithHandle]="true" />
            <z-resizable-panel [zDefaultSize]="panelSizes[1]" [zMin]="minPanelSizes[1]" class="overflow-hidden">
                <ng-container *ngTemplateOutlet="tabsSide">
                </ng-container>
            </z-resizable-panel>
        </z-resizable>
        }
    </div>
</section>

@if (!contract.containsForm && !isAnonymousUser && isSameOrganization) {
    <app-chat-bubble
        chatType="document"
        [chatConfig]="{
            contractId: contractId,
            documentTypeId: $any(contract).linkedDocType?._id || '',
            projectId: projectId,
            embeddingsStatus: !emptyDocument && !isRefreshing
        }" />
}
}
}
}

<ng-template #documentSide>
    <div class="w-full overflow-hidden h-full relative">
        <!-- Resize overlay to prevent iframe repaint during resize -->
        @if(isResizing) {
        <div class="absolute inset-0 z-50 bg-transparent cursor-col-resize"></div>
        }
        <div [ngClass]="bottomBarVisible ? 'h-[95%]' : 'h-[100%]'">
            <app-only-office-doc-editor [contractId]="contract._id" [user]="currentUser!" *ngIf="!showQuestionPanel"
                [configData]="config" #onlyOfficeDocEditor>
            </app-only-office-doc-editor>
        </div>
        <!-- <app-sharepoint></app-sharepoint> -->
        @if(bottomBarVisible){
        <div class="h-[5%] flex flex-1 w-full  items-center">
            @if(currentApprover?.email === currentUser?.email){
            @if(currentApprover?.status == CONTRACT_APPROVAL_STATUS.PENDING){
            <div class="flex flex-row gap-x-6 justify-center items-center w-full">
                <div class="flex flex-row ">
                    <div class="font-bont text-sm">
                        <span class="font-normal">Review the document and take the necessary action</span>
                    </div>
                </div>
                <div class="flex gap-x-3">
                    <app-button label="Approve" (clicked)="openApprovalDialog('Approve')" variant="outlined"
                        [disabled]="approvalActionLoading" severity="success" icon="pi pi-check" />
                    <app-button label="Reject" (clicked)="openApprovalDialog('Reject')" variant="outlined"
                        [disabled]="approvalActionLoading" severity="danger" icon="pi pi-times" />
                </div>
            </div>
            }

            @if(currentApprover?.status == CONTRACT_APPROVAL_STATUS.APPROVED && !isOwner){
            <div class="flex flex-row gap-x-6 justify-center items-center w-full">
                <div class="flex flex-row ">
                    <div class="font-bont text-sm">
                        You have <span class="text-success">approved</span> this Document
                    </div>
                </div>
            </div>
            }
            @if(currentApprover?.status == CONTRACT_APPROVAL_STATUS.REJECTED){
            <div class="flex flex-row gap-x-6 justify-center items-center w-full">
                <div class="flex flex-row ">
                    <div class="font-bont text-sm">
                        You have <span class="text-danger">rejected</span> this Document
                    </div>
                </div>
            </div>
            }
            }
        </div>
        }
    </div>
</ng-template>

<ng-template #tabsSide>
    <div class="relative w-full col-span-3 bg-white border-l-2 p-2 overflow-[100%] comments h-full">
        @if(!(this.isAnonymousUser || !this.isSameOrganization)){
        <i *ngIf="showQuestionPanel"
            class="p-1 border border-gray-300 rounded-base pi pi-angle-right absolute top-[25px] text-sm cursor-pointer text-gray-500"
            [style.z-index]="'5'" (click)="toggleQuestionPanel(false)"></i>
        <i *ngIf="!showQuestionPanel"
            class="p-1 border border-gray-300 rounded-base pi pi-angle-left absolute top-[25px] left-[8px] text-sm cursor-pointer text-gray-500"
            [style.z-index]="'5'" (click)="toggleQuestionPanel(true)"></i>
        }
        <div class="ml-3 h-full flex flex-col overflow-hidden">
            <!-- Tabs Component -->
            <app-tabs-panels [tabs]="tabsConfig" [activeTabValue]="activeTabValue" [scrollable]="true"
                [customClass]="'h-full'" [tabListClass]="'document-tabs border-b'" [tabPanelsClass]="'bg-white'"
                (tabChanged)="onTabChanged($event)" class="flex-1 flex flex-col overflow-hidden">
            </app-tabs-panels>
        </div>
    </div>
</ng-template>

<ng-template #tooltipContentAdobe>
    <div class="flex align-items-center">
        <span> Adobe sign </span>
    </div>
</ng-template>

<ng-template #tooltipContentDocu>
    <div class="flex align-items-center">
        <span> Docusign </span>
    </div>
</ng-template>

<app-dialog [visible]="approversDialog" title="Add user to the approval level" [fullscreenOnMobile]="true"
    class="max-w-[37.5rem] h-[31.25rem]" (closed)="onCloseApproverDialog()">
    <ng-template #bodyTemplate>
        <div class="flex flex-col flex-1 h-full px-6 py-4 overflow-y-auto">
            <p-iconField iconPosition="left">
                <div class="flex w-full items-center space-x-2">
                    <app-autocomplete [suggestions]="autoCompleteUsers" [(value)]="autoCompleteValue" [config]="{
                            placeholder: 'Add approvers by name or email',
                            showEmptyMessage: false,
                            dropdown: false,
                            inputStyleClass: 'border-0 outline-none'
                        }" [optionLabel]="'fullName'" (onComplete)="autoCompleteUsersMethod($event)"
                        (onSelect)="addInternalApprover($event)" [itemTemplate]="userItemTemplate"
                        class="flex-grow rounded-base border border-gray-300 h-10">
                    </app-autocomplete>
                    <ng-template #userItemTemplate let-user>
                        <div class="custom-item flex items-center p-2">
                            <div>
                                <app-user-name-display [user]="user" [variant]="'avatar-name'"></app-user-name-display>
                                <span class="block text-sm text-gray-500">{{ user.email }}</span>
                            </div>
                        </div>
                    </ng-template>
                    @if(validApproverEmail()) {
                    <app-button variant="filled" severity="primary" (clicked)="addExternalApprover()" label="Add" />
                    }
                </div>
            </p-iconField>

            <div class="flex flex-col mt-2 flex-1 overflow-y-auto no-scrollbar">
                @for (item of approvers; track $index) {
                <div pDraggable pDroppable
                    class="flex items-center space-x-2 text-black p-2 rounded-base transition-all ease-in-out"
                    (onDragStart)="dragStart($index)" (onDrop)="drop($index)">
                    <i class="pi pi-bars cursor-move text-gray-400 mr-2"></i>
                    <div class="relative inline-block">
                        <img [src]="item.user | userAvatar" alt="User Avatar" class="w-10 h-10 rounded-full" />
                        @if(item.type == USER_TYPE.EXTERNAL){
                        <span class="absolute bottom-0 right-0 w-6 h-6 ">
                            <img [src]="'images/external-badge.png' | assetUrl" alt="External Badge"
                                class="rounded-full" [pTooltip]="'External user'" />
                        </span>
                        }
                        @else if(isUserUnverified(item)){
                        <span
                            class="absolute bottom-0 right-0 w-6 h-6 flex items-center justify-center bg-gray-500 text-white rounded-full text-xs"
                            [pTooltip]="'Email Unverified'">
                            <i class="pi pi-exclamation-circle text-white text-sm"></i>
                        </span>
                        }
                    </div>
                    <div class="flex flex-col text-sm w-[50%]">
                        @if (editApprover[$index]) {
                        @if (item.type == USER_TYPE.EXTERNAL) {
                        <input [(ngModel)]="item.name" class="border bg-transparent rounded-base mb-0.5 p-0.5 pl-1.5" />
                        } @else {
                        <span class="p-0.5 pl-1.5">{{ item.name }}</span>
                        }
                        <input [(ngModel)]="item.email" class="border bg-transparent rounded-base p-0.5 pl-1.5" />
                        } @else {
                        <span class="p-0.5 pl-1.5">{{ item.name }}</span>
                        <span class="text-gray-500 p-0.5 pl-1.5">{{ item.email }}</span>
                        }
                    </div>
                    <div class="flex-1 flex justify-end items-center">
                        <div class="bg-sky-100 border-sky-200 border px-3 rounded-base text-sky-600">
                            Level {{$index + 1}}
                        </div>
                        <div class="h-full">
                            @if (item.type == USER_TYPE.EXTERNAL) {
                            <i class="pi border py-3 px-2.5 rounded-base ml-2 cursor-pointer"
                                (click)="editApproverFunc($index)"
                                [ngClass]="editApprover[$index] ? 'pi-check' : 'pi-pencil'"></i>
                            }
                            <i class="pi pi-trash border py-3 px-2.5 rounded-base text-danger ml-2 cursor-pointer"
                                (click)="removeApprover($index,'approver')"></i>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel" (clicked)="approversDialog=false" />
            <app-button variant="filled" severity="primary" icon="pi pi-save" (clicked)="saveApprovalWorkflow()"
                label="Save" />
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="signatoryDialog" title="Add user to the signatory level" [fullscreenOnMobile]="true"
    class="max-w-[37.5rem] h-[31.25rem]" (closed)="onCloseSignatoryDialog()">
    <ng-template #bodyTemplate>
        <div class="flex flex-col flex-1 h-full px-6 py-4 overflow-y-auto">
            <p-iconField iconPosition="left">
                <div class="flex w-full items-center space-x-2">
                    <app-autocomplete [suggestions]="autoCompleteUsers" [(value)]="autoCompleteValue" [config]="{
                            placeholder: 'Add signatories by name or email',
                            showEmptyMessage: false,
                            dropdown: false,
                            inputStyleClass: 'border-0 outline-none'
                        }" [optionLabel]="'fullName'" (onComplete)="autoCompleteUsersMethod($event)"
                        (onSelect)="addSignatory($event)" [itemTemplate]="signatoryUserItemTemplate"
                        class="flex-grow rounded-base border border-gray-300 h-10">
                    </app-autocomplete>
                    <ng-template #signatoryUserItemTemplate let-user>
                        <div class="custom-item flex items-center p-2">
                            <div>
                                <app-user-name-display [user]="user" [variant]="'avatar-name'"></app-user-name-display>
                            </div>
                        </div>
                    </ng-template>
                    <app-button variant="filled" severity="primary" (clicked)="addExternalSignatory()" label="Add"
                        [disabled]="!validApproverEmail()" />
                </div>
            </p-iconField>

            <div class="flex flex-col mt-2 flex-1 overflow-y-auto no-scrollbar">
                @for (item of signatories; track $index) {
                <div pDraggable pDroppable [dragHandle]="'.handle'"
                    class="flex items-center space-x-2 text-black p-2 rounded-base transition-all ease-in-out"
                    (onDragStart)="dragStart($index)" (drop)="dropSignatories($index)">
                    <i class="pi pi-bars cursor-move handle text-gray-400 mr-2"></i>
                    <div class="relative inline-block">
                        @if(item.type == USER_TYPE.EXTERNAL){
                        <span class="absolute bottom-0 right-0 w-6 h-6 ">
                            <img [src]="'images/external-badge.png' | assetUrl" alt="External Badge"
                                class="rounded-full" [pTooltip]="'External user'" />
                        </span>
                        }
                        @else if(isUserUnverified(item)){
                        <span
                            class="absolute bottom-0 right-0 w-6 h-6 flex items-center justify-center bg-gray-500 text-white rounded-full text-xs"
                            [pTooltip]="'Email Unverified'">
                            <i class="pi pi-exclamation-circle text-white text-sm"></i>
                        </span>
                        }
                    </div>
                    <div class="flex flex-col text-sm w-[50%]">
                        <app-user-name-display [user]="item.user" [fallbackText]="item.name"
                            [variant]="'avatar-name'"></app-user-name-display>
                        <span class="text-gray-500 p-0.5 pl-1.5">{{item.email}}</span>
                    </div>
                    <div class="flex-1 flex justify-end items-center">
                        <div class="bg-sky-100 border-sky-200 border px-3 rounded-base text-sky-600">Level {{$index+1}}
                        </div>
                        <i class="pi pi-trash border py-3 px-2.5 rounded-base text-danger ml-2 cursor-pointer"
                            (click)="removeApprover($index,'signatory')"></i>
                    </div>
                </div>
                }
            </div>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end gap-2">
            <app-button variant="outlined" severity="contrast" label="Cancel" (clicked)="signatoryDialog=false" />
            <app-button variant="filled" severity="primary" icon="pi pi-save" (clicked)="updateSignatories()"
                label="Save" />
        </div>
    </ng-template>
</app-dialog>


<app-dialog [visible]="showVersionsHistoryDialog" title="Version History" [fullscreenOnMobile]="true"
    class="max-w-[37.5rem] h-[31.25rem]" (closed)="onCloseApproverDialog()">
    <ng-template #bodyTemplate>
        <div class="flex flex-col flex-1 h-full px-6 py-4 overflow-y-auto">
            @if (!versions || versions.length == 0) {
            <div class="flex justify-center items-center h-full">
                <span class="text-gray-400">No versions available</span>
            </div>
            }
            <div class="flex flex-col mt-2 max-h-full overflow-y-auto overflow-hidden">
                <div class="timeline">
                    @for (item of versions; track $index) {
                    <div class="timeline-item flex space-x-4 group">
                        <div class="flex flex-col items-center">
                            <span class="timeline-dot w-4 h-4 rounded-full bg-orange-500 border border-gray-300"></span>
                            <div class="timeline-line flex-1 w-px bg-gray-300"></div>
                        </div>
                        <div
                            class="w-full flex flex-row items-center justify-between bg-gray-50 border space-y-1 p-2 mb-2 cursor-pointer text-black rounded-base transition-all ease-in-out hover:bg-white">
                            <div class="w-full flex flex-col" (click)="showVersion(item)">
                                <span class="font-bold text-md">{{ item.name }}</span>
                                <div class="flex items-center gap-2">
                                    <span class="text-gray-500">
                                        {{ item.updatedAt | date: 'mediumDate' }} at
                                        {{ item.updatedAt | date: 'shortTime' }}
                                    </span>
                                    -
                                    <app-user-name-display [user]="item.createdBy"
                                        [variant]="'avatar-name'"></app-user-name-display>
                                </div>
                            </div>
                            <div class="flex-1 justify-end items-center cursor-pointer"
                                (click)="$event.preventDefault();downloadVersion(item.version , $index)">
                                <div class="h-full flex">
                                    <i class="pi pi-download border py-3 px-2.5 rounded-base text-blue-600 ml-2"></i>
                                </div>
                            </div>
                            <div class="flex-1 justify-end items-center cursor-pointer"
                                (click)="$event.preventDefault();deleteVersion(item.version)">
                                <div class="h-full flex">
                                    <i class="pi pi-trash border py-3 px-2.5 rounded-base text-danger ml-2"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </ng-template>
</app-dialog>


<app-dialog [visible]="milestonesDialog" title="Add Milestones" [fullscreenOnMobile]="true"
    class="max-w-[70vw] h-[90vh]" (closed)="milestonesDialog = false">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 h-full overflow-y-auto">
            <app-milestones #milestonesComponent [milestones]="milestones" (save)="onMilestoneSave($event)"
                (cancel)="onMilestoneCancel()">
            </app-milestones>
        </div>
    </ng-template>
</app-dialog>

<app-dialog [visible]="supportTicketDialog" title="Raise a Support Ticket" [fullscreenOnMobile]="true"
    class="max-w-[40rem] h-[41rem]" (closed)="onSupportTicketDialogHide()">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4 h-full overflow-y-auto">
            <app-support-ticket-form #supportTicketForm [isDialog]="true"
                (ticketSubmitted)="onSupportTicketSubmitted()">
            </app-support-ticket-form>
        </div>
    </ng-template>
</app-dialog>

<app-capture-issue #captureIssue (captureCompleted)="onCaptureCompleted($event)"></app-capture-issue>

<app-share-access-dialog [user]="shareAccessData.user" [visible]="shareAccessData.visible"
    [orgLevel]="shareAccessData.orgLevel" [workspaceLevel]="shareAccessData.workspaceLevel"
    [resource]="shareAccessData.resource" [feature]="shareAccessData.feature"
    (visibleChange)="shareAccessData.visible = $event" [permissions]="shareAccessData.permissions"
    (userAccessChanged)="shareAccessData.onComplete($event)"></app-share-access-dialog>

<!-- Workspace Mismatch Dialog -->
<app-dialog [visible]="workspaceMismatchDialog" title="You're in the Wrong Workspace" [showCloseButton]="false"
    [closable]="false" class="max-w-[30rem]">
    <ng-template #bodyTemplate>
        <div class="px-6 py-4">
            <p class="mb-0">This document is available in a different workspace. Please switch to the appropriate
                workspace to access it.</p>
        </div>
    </ng-template>
    <ng-template #footerTemplate>
        <div class="flex justify-end">
            <app-button label="Switch Workspace" (clicked)="switchToContractWorkspace()" severity="primary"
                variant="filled" icon="pi pi-sign-out" />
        </div>
    </ng-template>
</app-dialog>
